import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { FilingsService } from './filings.service';
import { MailService } from './mail-upload/mail.service';
import { SelectionService } from './selection/selection.service';

/**
 * The pane's entry point: several selected mails, or a batch still holding on
 * to its mails, open on the batch, a mail
 * filed before on where it went, any other on the filing steps. With no mail
 * at all it opens an empty page, and the shell says that nothing is selected.
 * Never activates, it only redirects: Home sends every change back to `/`, and
 * a navigation to the URL already shown would be skipped.
 *
 * A record that cannot be read costs the reminder, not the filing steps. Filing
 * itself reads the record again and refuses when that fails.
 */
export const openMailGuard: CanActivateFn = async (): Promise<UrlTree> => {
  const router = inject(Router);
  const filingsService = inject(FilingsService);
  const mailService = inject(MailService);
  const selectionService = inject(SelectionService);
  const selection = await selectionService.load();

  // A batch on its mails keeps the pane, whatever is selected now.
  if (selection.mails.length > 1 || selectionService.batchHeld()) {
    return router.createUrlTree(['/batch']);
  }

  if (mailService.getCurrentItemId() === null) {
    return router.createUrlTree(['/none']);
  }

  let filed = false;

  try {
    filed = (await filingsService.load()).length > 0;
  } catch (error) {
    console.warn('Reading where the mail was filed failed:', error);
  }

  return router.createUrlTree([filed ? '/filed' : '/file']);
};
